// extracted by mini-css-extract-plugin
export var root = "_zw-0";
export var scroll = "_zw-1";
export var thumb = "_zw-3";
export var track = "_zw-2";